module.exports = __webpack_public_path__ + "img/bgs.376a17c.png";